import moment from 'moment'
import {
    SET_ACCESS_TOKEN,
    SET_ACTIVE_ORGANIZATION,
    SET_DEFAULT_ORGANIZATION,
    SET_EMAIL, SET_EXPIRES_IN,
    SET_SPEED_UNIT,
    SET_FAMILY_NAME,
    SET_GIVEN_NAME,
    SET_TOKEN_TYPE,
    SET_PERMISSIONS,
    SET_USER_ID,
    SET_EXPIRATION_ISO_DATE,
    SET_USER_SESSION
} from '@/store/modules/auth/mutations'

const setCredentials = ({ commit }, payload) => {
    const expirationIsoDate = moment().add('seconds', payload.expires_in).toISOString();

    localStorage.setItem('accessToken', payload.access_token)
    localStorage.setItem('expiresIn', payload.expires_in)
    localStorage.setItem('expirationIsoDate', expirationIsoDate)
    localStorage.setItem('tokenType', payload.token_type)
    commit(SET_ACCESS_TOKEN, payload.access_token)
    commit(SET_EXPIRES_IN, payload.expires_in)
    commit(SET_TOKEN_TYPE, payload.token_type)
}

const setUserInfo = async ({ commit, dispatch }, payload) => {
    localStorage.setItem('defaultOrganization', payload.default_organization)
    localStorage.setItem('activeOrganization', payload.default_organization)
    localStorage.setItem('email', payload.email)
    localStorage.setItem('givenName', payload.given_name)
    localStorage.setItem('familyName', payload.family_name)
    localStorage.setItem('permissions', payload.permissions)
    localStorage.setItem('userId', payload.user_id)
    commit(SET_DEFAULT_ORGANIZATION, payload.default_organization)
    commit(SET_EMAIL, payload.email)
    commit(SET_GIVEN_NAME, payload.given_name)
    commit(SET_FAMILY_NAME, payload.family_name)
    commit(SET_PERMISSIONS, payload.permissions)
    commit(SET_USER_ID, payload.user_id)
    await dispatch('setActiveOrganization', payload.default_organization)
}

const setUserSession = async ({ commit, dispatch }, payload) => {
    commit(SET_USER_SESSION, payload)
}

const setUserSettings = async ({ commit, dispatch }, payload) => {
    localStorage.setItem('speedUnit', payload.speedUnit)
    commit(SET_SPEED_UNIT, payload.speedUnit)
}

const setActiveOrganization = ({ commit, dispatch }, payload) => {
    localStorage.setItem('activeOrganization', payload)
    dispatch('brandModule/setBranding', null, { root: true })
    commit(SET_ACTIVE_ORGANIZATION, payload)
}

const authorizeFromLocalStorage = ({ commit, dispatch }) => {
    const accessToken = localStorage.getItem('accessToken')
    const expirationIsoDate = localStorage.getItem('expirationIsoDate')

    if (null != accessToken && null != expirationIsoDate && moment(expirationIsoDate).isAfter(moment())) {
        commit(SET_ACCESS_TOKEN, accessToken)
        commit(SET_EXPIRES_IN, localStorage.getItem('expiresIn'))
        commit(SET_TOKEN_TYPE, localStorage.getItem('tokenType'))
        commit(SET_DEFAULT_ORGANIZATION, localStorage.getItem('defaultOrganization'))
        commit(SET_ACTIVE_ORGANIZATION, localStorage.getItem('activeOrganization'))
        commit(SET_EMAIL, localStorage.getItem('email'))
        commit(SET_GIVEN_NAME, localStorage.getItem('givenName'))
        commit(SET_FAMILY_NAME, localStorage.getItem('familyName'))
        commit(SET_PERMISSIONS, localStorage.getItem('permissions'))
        commit(SET_USER_ID, localStorage.getItem('userId'))
    } else {
        dispatch('clearCredentials')
        dispatch('signalR/clearSignalRConnection', { }, { root: true })
        dispatch('signalRDeviceCommand/clearSignalRConnection', { }, { root: true })
    }
}

const clearCredentials = ({ commit }) => {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('expiresIn')
    localStorage.removeItem('tokenType')
    localStorage.removeItem('defaultOrganization')
    localStorage.removeItem('email')
    localStorage.removeItem('givenName')
    localStorage.removeItem('familyName')
    localStorage.removeItem('activeOrganization')
    localStorage.removeItem('lastRoute')
    localStorage.removeItem('permissions')
    localStorage.removeItem('userId')
    localStorage.removeItem('expirationIsoDate')
    commit(SET_ACCESS_TOKEN, null)
    commit(SET_EXPIRES_IN, null)
    commit(SET_TOKEN_TYPE, null)
    commit(SET_DEFAULT_ORGANIZATION, null)
    commit(SET_ACTIVE_ORGANIZATION, null)
    commit(SET_SPEED_UNIT, null)
    commit(SET_EMAIL, null)
    commit(SET_GIVEN_NAME, null)
    commit(SET_FAMILY_NAME, null)
    commit(SET_PERMISSIONS, null)
    commit(SET_USER_ID, null)
    commit(SET_EXPIRATION_ISO_DATE, null)
}

export default {
    setCredentials,
    setUserInfo,
    setUserSettings,
    setUserSession,
    setActiveOrganization,
    authorizeFromLocalStorage,
    clearCredentials
}
